export default __webpack_public_path__ + "static/media/sticker.f1abfb90.png";